import React from "react";
import {
  IconFood,
  IconShopping,
  IconCar,
  IconUtilities,
  IconWifi,
  IconPlay,
  IconFilm,
  IconTrending,
  IconPiggy,
  IconOther,
  IconBanknote,
  IconBriefcase,
  IconStar,
  IconBitcoin,
} from "../components/icons";

export const ASSET_GROUPS = {
  LIQUID: {
    id: "LIQUID",
    title: "สภาพคล่อง",
    types: ["Bank", "Cash", "Wallet", "USDT", "Savings"],
    color: "#10B981",
  },
  INVESTMENT: {
    id: "INVESTMENT",
    title: "การลงทุน",
    types: ["Lottery", "Insurance", "Fund", "Stock", "BTC", "Gold"],
    color: "#3B82F6",
  },
  PERSONAL: {
    id: "PERSONAL",
    title: "ทรัพย์สินส่วนตัว",
    types: ["Car", "House", "Personal"],
    color: "#8B5CF6",
  },
  LIABILITY: {
    id: "LIABILITY",
    title: "หนี้สิน",
    types: ["Credit Card", "Loan", "Debt"],
    color: "#EF4444",
  },
};

export const CATEGORIES_CONFIG = {
  Expense: [
    {
      label: "อาหารและเครื่องดื่ม",
      icon: <IconFood size={24} />,
      color: "text-orange-400 bg-orange-400/20",
    },
    {
      label: "ช้อปปิ้ง",
      icon: <IconShopping size={24} />,
      color: "text-pink-400 bg-pink-400/20",
    },
    {
      label: "ค่าเดินทาง",
      icon: <IconCar size={24} />,
      color: "text-yellow-400 bg-yellow-400/20",
    },
    {
      label: "ค่าไฟค่าน้ำ",
      icon: <IconUtilities size={24} />,
      color: "text-blue-400 bg-blue-400/20",
    },
    {
      label: "ค่าอินเตอร์เน็ต",
      icon: <IconWifi size={24} />,
      color: "text-cyan-400 bg-cyan-400/20",
    },
    {
      label: "Youtube",
      icon: <IconPlay size={24} />,
      color: "text-red-500 bg-red-500/20",
    },
    {
      label: "Netflix",
      icon: <IconFilm size={24} />,
      color: "text-red-600 bg-red-600/20",
    },
    {
      label: "ลงทุน",
      icon: <IconTrending size={24} />,
      color: "text-green-400 bg-green-400/20",
    },
    {
      label: "ออมเงิน",
      icon: <IconPiggy size={24} />,
      color: "text-purple-400 bg-purple-400/20",
    },
    {
      label: "อื่นๆ",
      icon: <IconOther size={24} />,
      color: "text-slate-400 bg-slate-400/20",
    },
  ],
  Income: [
    {
      label: "เงินเดือน",
      icon: <IconBanknote size={24} />,
      color: "text-emerald-400 bg-emerald-400/20",
    },
    {
      label: "Freelance",
      icon: <IconBriefcase size={24} />,
      color: "text-purple-400 bg-purple-400/20",
    },
    {
      label: "เงินรางวัล",
      icon: <IconStar size={24} />,
      color: "text-yellow-400 bg-yellow-400/20",
    },
    {
      label: "กำไรจาก Crypto",
      icon: <IconBitcoin size={24} />,
      color: "text-orange-500 bg-orange-500/20",
    },
    {
      label: "อื่นๆ",
      icon: <IconOther size={24} />,
      color: "text-slate-400 bg-slate-400/20",
    },
  ],
};

export const THAI_MONTHS_SHORT = [
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค.",
];
export const CHART_COLORS = [
  "#3B82F6",
  "#10B981",
  "#F59E0B",
  "#EF4444",
  "#8B5CF6",
  "#EC4899",
  "#6366F1",
  "#14B8A6",
  "#84CC16",
];
export const EXCHANGE_RATE = 34.5;
